module.exports = __webpack_public_path__ + "assets/neirokid.ru.01edcf124182fb462d1f568d8dc81e5f9283c88824ec53304dae9f0ee0d61334.jpg";